(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("pakhshkit-js"));
	else if(typeof define === 'function' && define.amd)
		define(["pakhshkit-js"], factory);
	else if(typeof exports === 'object')
		exports["ottanalytics"] = factory(require("pakhshkit-js"));
	else
		root["pakhshkit"] = root["pakhshkit"] || {}, root["pakhshkit"]["ottanalytics"] = factory(root["pakhshkit"]["core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAME = exports.VERSION = undefined;

var _pakhshkitJs = __webpack_require__(0);

var _ottAnalytics = __webpack_require__(2);

exports.default = _ottAnalytics.OttAnalytics;
exports.VERSION = "0.5.0";
exports.NAME = "@pakhshkit-js/pakhshkit-js-ott-analytics";

/**
 * The plugin name.
 * @type {string}
 * @const
 */

var pluginName = 'ottAnalytics';

(0, _pakhshkitJs.registerPlugin)(pluginName, _ottAnalytics.OttAnalytics);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookmarkError = exports.BookmarkEvent = exports.OttAnalytics = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pakhshkitJs = __webpack_require__(0);

var _pakhshkitBookmarkService = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MEDIA_TYPE = 'MEDIA';
var BookmarkEvent = {
  LOAD: 'LOAD',
  PLAY: 'PLAY',
  STOP: 'STOP',
  PAUSE: 'PAUSE',
  FINISH: 'FINISH',
  FIRST_PLAY: 'FIRST_PLAY',
  BITRATE_CHANGE: 'BITRATE_CHANGE',
  HIT: 'HIT'
};

var BookmarkError = {
  BOOKMARK_ERROR: 'bookmarkerror',
  CONCURRENCY_LIMIT: 'concurrencylimit'
};

var CONCURRENCY_ERROR_CODE = '4001';

var OttAnalytics = function (_BasePlugin) {
  _inherits(OttAnalytics, _BasePlugin);

  _createClass(OttAnalytics, null, [{
    key: 'isValid',


    /**
     * Whether the ima plugin is valid.
     * @static
     * @override
     * @public
     */
    value: function isValid() {
      return true;
    }
    /**
     * The default configuration of the plugin.
     * @type {Object}
     * @static
     */

  }]);

  /**
   * @constructor
   * @param {string} name - The plugin name.
   * @param {Player} player - The player instance.
   * @param {Object} config - The plugin config.
   */
  function OttAnalytics(name, player, config) {
    _classCallCheck(this, OttAnalytics);

    var _this = _possibleConstructorReturn(this, (OttAnalytics.__proto__ || Object.getPrototypeOf(OttAnalytics)).call(this, name, player, config));

    _this._isPlaying = false;
    _this._isFinished = false;
    _this._isStopped = false;
    _this._fileId = 0;
    _this._didFirstPlay = false;
    _this._mediaHitInterval = null;
    _this._playerDidError = false;

    if (_this.config.serviceUrl) {
      _this._registerListeners();
    } else {
      _this.logger.warn('No service URL provided. Tracking aborted');
    }
    return _this;
  }

  /**
   * reset the plugin.
   * @override
   * @public
   * @returns {void}
   */


  _createClass(OttAnalytics, [{
    key: 'reset',
    value: function reset() {
      this._clearMediaHitInterval();
      this._maybeSendStop();
      this._didFirstPlay = false;
      this._playerDidError = false;
    }

    /**
     * Destroys the plugin.
     * @override
     * @public
     * @returns {void}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this._maybeSendStop();
      this.eventManager.destroy();
    }
  }, {
    key: '_maybeSendStop',
    value: function _maybeSendStop() {
      if (!(this._isFinished || this._isStopped)) {
        this._isStopped = true;
        this._sendAnalytics(BookmarkEvent.STOP, this._eventParams);
      }
    }

    /**
     * Registers the player listeners.
     * @private
     * @returns {void}
     */

  }, {
    key: '_registerListeners',
    value: function _registerListeners() {
      var _this2 = this;

      var PlayerEvent = this.player.Event;
      this.eventManager.listen(this.player, PlayerEvent.FIRST_PLAY, function () {
        return _this2._onFirstPlay();
      });
      this.eventManager.listen(this.player, PlayerEvent.PLAY, function () {
        return _this2._onPlay();
      });
      this.eventManager.listen(this.player, PlayerEvent.PAUSE, function () {
        return _this2._onPause();
      });
      this.eventManager.listen(this.player, PlayerEvent.ENDED, function () {
        return _this2._onEnded();
      });
      this.eventManager.listen(this.player, PlayerEvent.SEEKED, function () {
        return _this2._onSeeked();
      });
      this.eventManager.listen(this.player, PlayerEvent.ERROR, function (e) {
        return _this2._onError(e);
      });
      this.eventManager.listen(this.player, PlayerEvent.VIDEO_TRACK_CHANGED, function () {
        return _this2._onVideoTrackChanged();
      });
      this.eventManager.listen(this.player, PlayerEvent.SOURCE_SELECTED, function (event) {
        return _this2._onSourceSelected(event);
      });
      this.eventManager.listen(this.player, PlayerEvent.MEDIA_LOADED, function () {
        return _this2._onMediaLoaded();
      });
    }

    /**
     * The source selected event listener.
     * @param {Object} event - The event object.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onSourceSelected',
    value: function _onSourceSelected(event) {
      try {
        var source = event.payload.selectedSource[0];
        var parts = source.id.split(',');
        var id = parts[0];
        this._fileId = parseInt(id);
      } catch (e) {
        this.logger.warn('Unable to parse file ID');
      }
    }

    /**
     * The media loaded event listener.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onMediaLoaded',
    value: function _onMediaLoaded() {
      this._sendAnalytics(BookmarkEvent.LOAD, this._eventParams);
    }

    /**
     * The play event listener.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onPlay',
    value: function _onPlay() {
      this._isPlaying = true;
      this._isStopped = false;
      this._isFinished = false;
      this._startMediaHitInterval();
      this._sendAnalytics(BookmarkEvent.PLAY, this._eventParams);
    }

    /**
     * The pause event listener.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onPause',
    value: function _onPause() {
      this._isPlaying = false;
      if (this._didFirstPlay) {
        this._sendAnalytics(BookmarkEvent.PAUSE, this._eventParams);
      }
    }

    /**
     * The ended event listener.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onEnded',
    value: function _onEnded() {
      this._isPlaying = false;
      this._isFinished = true;
      this._clearMediaHitInterval();
      this._sendAnalytics(BookmarkEvent.FINISH, this._eventParams);
    }

    /**
     * The error event listener.
     * @param {FakeEvent} event - player eventgit chec
     * @private
     * @returns {void}
     */

  }, {
    key: '_onError',
    value: function _onError(event) {
      if (event.payload && event.payload.severity === _pakhshkitJs.Error.Severity.CRITICAL) {
        this._isPlaying = false;
        this._playerDidError = true;
        this._clearMediaHitInterval();
      }
    }

    /**
     * The first play event listener.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onFirstPlay',
    value: function _onFirstPlay() {
      this._didFirstPlay = true;
      this._sendAnalytics(BookmarkEvent.FIRST_PLAY, this._eventParams);
    }

    /**
     * Sets _playFromContinue to false on seeked event.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onSeeked',
    value: function _onSeeked() {
      this._playFromContinue = false;
    }

    /**
     * Send BITRATE_CHANGE analytic.
     * @private
     * @returns {void}
     */

  }, {
    key: '_onVideoTrackChanged',
    value: function _onVideoTrackChanged() {
      this._sendAnalytics(BookmarkEvent.BITRATE_CHANGE, this._eventParams);
    }

    /**
     * Get the player params which relevant to analytics request.
     * @private
     * @returns {Object} - The player params
     */

  }, {
    key: '_sendAnalytics',


    /**
     * Send analytics.
     * @param {string} action - The action
     * @param {string} params - The params
     * @private
     * @returns {void}
     */
    value: function _sendAnalytics(action, params) {
      var _this3 = this;

      if (!this._validate(action)) {
        return;
      }
      var playerData = {
        action: action,
        averageBitrate: 0,
        totalBitrate: 0,
        currentBitrate: 0,
        fileId: params.fileId
      };
      var bookMark = {
        type: params.mediaType,
        id: params.mediaId,
        position: params.position,
        playerData: playerData
      };
      var request = _pakhshkitBookmarkService.OTTBookmarkService.add(this.config.serviceUrl, this.config.vs, bookMark);
      this.logger.debug('sending bookmark', bookMark);
      request.doHttpRequest().then(function (data) {
        _this3.logger.debug('bookmark response', data);
        if (_this3._resultHasError(data)) {
          if (_this3._getErrorCode(data) === CONCURRENCY_ERROR_CODE) {
            _this3.player.dispatchEvent(new _pakhshkitJs.FakeEvent(BookmarkError.CONCURRENCY_LIMIT, data));
            _this3.logger.warn('bookmark concurrency block returned');
          } else {
            _this3.player.dispatchEvent(new _pakhshkitJs.FakeEvent(BookmarkError.BOOKMARK_ERROR, data));
            _this3.logger.warn('bookmark error returned');
          }
        }
      }, function (err) {
        _this3.logger.warn('Failed to send analytics event', bookMark, err);
      });
    }

    /**
     * check if server returned error response
     * @param {object} data - the server response
     * @returns {boolean} - if server returned an error object
     * @private
     */

  }, {
    key: '_resultHasError',
    value: function _resultHasError(data) {
      return !!(data.result && data.result.error);
    }

    /**
     * get the error code from the server response
     * @param {object} data - the server response
     * @returns {string} - the error code
     * @private
     */

  }, {
    key: '_getErrorCode',
    value: function _getErrorCode(data) {
      return data.result.error.code;
    }
  }, {
    key: '_validate',
    value: function _validate(action) {
      if (this._playerDidError) {
        return false;
      }
      if (!this.config.entryId) {
        this._logMissingParam('entryId');
        return false;
      }
      if (!this._fileId) {
        this._logMissingParam('fileId');
        return false;
      }
      if (this.config.isAnonymous) {
        this.logger.info('block report for anonymous user');
        return false;
      }
      var isMediaHit = action === BookmarkEvent.HIT;
      if (isMediaHit && this.config.disableMediaHit) {
        this.logger.info('block MediaHit report');
        return false;
      }
      if (!isMediaHit && this.config.disableMediaMark) {
        this.logger.info('block MediaMark report');
        return false;
      }
      return true;
    }
  }, {
    key: '_logMissingParam',
    value: function _logMissingParam(missingParam) {
      this.logger.warn('block report because of missing param ' + missingParam);
    }

    /**
     * Starts the media hit interval.
     * @private
     * @returns {void}
     */

  }, {
    key: '_startMediaHitInterval',
    value: function _startMediaHitInterval() {
      var _this4 = this;

      if (!this.player.isLive() || this.config.experimentalEnableLiveMediaHit) {
        this._clearMediaHitInterval();
        this._mediaHitInterval = setInterval(function () {
          if (_this4._isPlaying) {
            if (_this4._eventParams.position === 0) {
              _this4.logger.debug('prevent sending MediaHit');
            } else {
              _this4._sendAnalytics(BookmarkEvent.HIT, _this4._eventParams);
            }
          }
        }, this.config.mediaHitInterval * 1000);
      }
    }

    /**
     * Clears the media hit interval.
     * @private
     * @returns {void}
     */

  }, {
    key: '_clearMediaHitInterval',
    value: function _clearMediaHitInterval() {
      if (this._mediaHitInterval) {
        clearInterval(this._mediaHitInterval);
        this._mediaHitInterval = null;
      }
    }
  }, {
    key: '_eventParams',
    get: function get() {
      return {
        mediaType: MEDIA_TYPE,
        fileId: this._fileId,
        mediaId: this.config.entryId,
        position: this.player.currentTime
      };
    }
  }]);

  return OttAnalytics;
}(_pakhshkitJs.BasePlugin);

OttAnalytics.defaultConfig = {
  mediaHitInterval: 30,
  isAnonymous: true,
  startTime: null,
  disableMediaHit: false,
  disableMediaMark: false,
  experimentalEnableLiveMediaHit: false
};
exports.OttAnalytics = OttAnalytics;
exports.BookmarkEvent = BookmarkEvent;
exports.BookmarkError = BookmarkError;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bookmark=t():(e.pakhshkit=e.pakhshkit||{},e.pakhshkit.services=e.pakhshkit.services||{},e.pakhshkit.services.bookmark=t())}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=11)}([function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new Map;r(this,e),this.headers=t}return i(e,[{key:"getUrl",value:function(e){return e+"/service/"+this.service+(this.action?"/action/"+this.action:"")}},{key:"doHttpRequest",value:function(){var e=this;if(!this.url)throw new Error("serviceUrl is mandatory for request builder");var t=new XMLHttpRequest;return new Promise(function(n,r){t.onreadystatechange=function(){if(4===t.readyState)if(200===t.status){var e=JSON.parse(t.responseText);e&&"object"===(void 0===e?"undefined":o(e))&&e.code&&e.message?r(e):n(e)}else r(t.responseText)},t.open(e.method,e.url),e.headers.forEach(function(e,n){t.setRequestHeader(n,e)}),t.send(e.params)})}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),t.OTTConfiguration=void 0;var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(3),u={serviceParams:{apiVersion:"4.7.1"}},a=function(){function e(){r(this,e)}return o(e,null,[{key:"set",value:function(e){e&&Object.assign(u,e)}},{key:"get",value:function(){return(0,i.clone)(u)}}]),e}();t.default=a,t.OTTConfiguration=a},,function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=function e(t){var n=void 0;return Array.isArray(t)?(n=t.length>0?t.slice(0):[],n.forEach(function(t,o){("object"===(void 0===t?"undefined":r(t))&&t!=={}||Array.isArray(t)&&t.length>0)&&(n[o]=e(t))})):"object"===(void 0===t?"undefined":r(t))?(n=Object.assign({},t),Object.keys(n).forEach(function(t){("object"===r(n[t])&&n[t]!=={}||Array.isArray(n[t])&&n[t].length>0)&&(n[t]=e(n[t]))})):n=t,n};t.clone=o},function(e,t,n){"use strict";function r(e){return e?a.get(e):a}function o(e){return r(e).getLevel()}function i(e,t){r(t).setLevel(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.setLogLevel=t.getLogLevel=t.LogLevel=void 0;var u=n(7),a=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(u),s={DEBUG:a.DEBUG,INFO:a.INFO,TIME:a.TIME,WARN:a.WARN,ERROR:a.ERROR,OFF:a.OFF};a.useDefaults({defaultLevel:a.ERROR}),t.default=r,t.LogLevel=s,t.getLogLevel=o,t.setLogLevel=i},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function e(t){r(this,e),this.hasError=!1,"VidiunAPIException"===t.objectType?(this.hasError=!0,this.error=new i(t.code,t.message)):t.error&&"VidiunAPIException"===t.error.objectType?(this.hasError=!0,this.error=new i(t.error.code,t.error.message)):this.data=t};t.default=o;var i=function e(t,n){r(this,e),this.code=t,this.message=n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.MultiRequestResult=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),l=r(c),f=n(4),p=r(f),v=n(5),d=r(v),y=function(e){function t(){var e,n,r,o;i(this,t);for(var a=arguments.length,s=Array(a),c=0;c<a;c++)s[c]=arguments[c];return n=r=u(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(s))),r.requests=[],o=n,u(r,o)}return a(t,e),s(t,[{key:"add",value:function(e){this.requests.push(e);var t={},n={service:e.service,action:e.action};return Object.assign(t,o({},this.requests.length,Object.assign(n,e.params))),Object.assign(t,this.params),this.params=t,this}},{key:"execute",value:function(){var e=this;try{this.params=JSON.stringify(this.params)}catch(e){t._logger.error(""+e.message)}return new Promise(function(t,n){e.doHttpRequest().then(function(e){t(new h(e))},function(e){n("Error on multiRequest execution, error <"+e+">.")})})}}]),t}(l.default);y._logger=(0,p.default)("MultiRequestBuilder"),t.default=y;var h=t.MultiRequestResult=function e(t){var n=this;i(this,e),this.results=[],this.success=!0,(t.result?t.result:t).forEach(function(t){var r=new d.default(t);if(n.results.push(r),r.hasError)return e._logger.error("Service returned an error with error code: "+r.error.code+" and message: "+r.error.message+"."),void(n.success=!1)})};h._logger=(0,p.default)("MultiRequestResult")},function(e,t,n){var r,o;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
!function(i){"use strict";var u={};u.VERSION="1.4.1";var a,s={},c=function(e,t){return function(){return t.apply(e,arguments)}},l=function(){var e,t,n=arguments,r=n[0];for(t=1;t<n.length;t++)for(e in n[t])e in r||!n[t].hasOwnProperty(e)||(r[e]=n[t][e]);return r},f=function(e,t){return{value:e,name:t}};u.DEBUG=f(1,"DEBUG"),u.INFO=f(2,"INFO"),u.TIME=f(3,"TIME"),u.WARN=f(4,"WARN"),u.ERROR=f(8,"ERROR"),u.OFF=f(99,"OFF");var p=function(e){this.context=e,this.setLevel(e.filterLevel),this.log=this.info};p.prototype={setLevel:function(e){e&&"value"in e&&(this.context.filterLevel=e)},getLevel:function(){return this.context.filterLevel},enabledFor:function(e){var t=this.context.filterLevel;return e.value>=t.value},debug:function(){this.invoke(u.DEBUG,arguments)},info:function(){this.invoke(u.INFO,arguments)},warn:function(){this.invoke(u.WARN,arguments)},error:function(){this.invoke(u.ERROR,arguments)},time:function(e){"string"==typeof e&&e.length>0&&this.invoke(u.TIME,[e,"start"])},timeEnd:function(e){"string"==typeof e&&e.length>0&&this.invoke(u.TIME,[e,"end"])},invoke:function(e,t){a&&this.enabledFor(e)&&a(t,l({level:e},this.context))}};var v=new p({filterLevel:u.OFF});!function(){var e=u;e.enabledFor=c(v,v.enabledFor),e.debug=c(v,v.debug),e.time=c(v,v.time),e.timeEnd=c(v,v.timeEnd),e.info=c(v,v.info),e.warn=c(v,v.warn),e.error=c(v,v.error),e.log=e.info}(),u.setHandler=function(e){a=e},u.setLevel=function(e){v.setLevel(e);for(var t in s)s.hasOwnProperty(t)&&s[t].setLevel(e)},u.getLevel=function(){return v.getLevel()},u.get=function(e){return s[e]||(s[e]=new p(l({name:e},v.context)))},u.createDefaultHandler=function(e){e=e||{},e.formatter=e.formatter||function(e,t){t.name&&e.unshift("["+t.name+"]")};var t={},n=function(e,t){Function.prototype.apply.call(e,console,t)};return"undefined"==typeof console?function(){}:function(r,o){r=Array.prototype.slice.call(r);var i,a=console.log;o.level===u.TIME?(i=(o.name?"["+o.name+"] ":"")+r[0],"start"===r[1]?console.time?console.time(i):t[i]=(new Date).getTime():console.timeEnd?console.timeEnd(i):n(a,[i+": "+((new Date).getTime()-t[i])+"ms"])):(o.level===u.WARN&&console.warn?a=console.warn:o.level===u.ERROR&&console.error?a=console.error:o.level===u.INFO&&console.info?a=console.info:o.level===u.DEBUG&&console.debug&&(a=console.debug),e.formatter(r,o),n(a,r))}},u.useDefaults=function(e){u.setLevel(e&&e.defaultLevel||u.DEBUG),u.setHandler(u.createDefaultHandler(e))},r=u,void 0!==(o="function"==typeof r?r.call(t,n,t,e):r)&&(e.exports=o)}()},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(12),c=r(s),l=n(0),f=r(l),p=n(1),v=r(p),d=function(e){function t(){return o(this,t),i(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return u(t,e),a(t,null,[{key:"add",value:function(e,t,n){var r=new Map;r.set("Content-Type","application/json");var o=new f.default(r);o.service="bookmark",o.action="add",o.method="POST",o.url=o.getUrl(e);var i={objectType:"VidiunBookmarkPlayerData",action:n.playerData.action,averageBitrate:n.playerData.averageBitrate,totalBitrate:n.playerData.totalBitrate,currentBitrate:n.playerData.currentBitrate,fileId:n.playerData.fileId},u={objectType:"VidiunBookmark",type:n.type,id:n.id,position:n.position,playerData:i},a=v.default.get(),s=a.serviceParams;return Object.assign(s,{bookmark:u,vs:t}),o.params=JSON.stringify(s),o}}]),t}(c.default);t.default=d},,,function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.VERSION=t.NAME=t.RequestBuilder=t.OTTConfiguration=t.OTTBookmarkService=void 0;var o=n(0),i=r(o),u=n(1),a=r(u),s=n(8),c=r(s);t.OTTBookmarkService=c.default,t.OTTConfiguration=a.default,t.RequestBuilder=i.default,t.NAME="pakhshkit-js-providers-bookmark-service",t.VERSION="2.3.2"},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(6),a=r(u),s=n(1),c=r(s),l=function(){function e(){o(this,e)}return i(e,null,[{key:"getMultiRequest",value:function(e,t){var n=c.default.get(),r=n.serviceParams;e&&Object.assign(r,{vs:e}),t&&Object.assign(r,{partnerId:t});var o=new Map;o.set("Content-Type","application/json");var i=new a.default(o);return i.method="POST",i.service="multirequest",i.url=i.getUrl(n.serviceUrl),i.params=r,i}}]),e}();t.default=l}])});
//# sourceMappingURL=pakhshkit-bookmark-service.js.map

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// pakhshkit-ott-analytics.js


// WEBPACK FOOTER //
// ott-analytics/pakhshkit-ott-analytics.js